import api from '@/api/api';

const DOMAIN = '/available-dates';

const get = async (
	professional_id: string,
): Promise<AvailableDates.SessionAvailableDatesResponse> => {
	const { data } = await api.get(
		`${DOMAIN}/${professional_id}?include_availability=true`,
	);
	return data;
};

const create = async (
	body: AvailableDates.Create,
): Promise<AvailableDates.AvailableDate> => {
	const { data } = await api.post(`${DOMAIN}`, body);
	return data;
};

const patch = async (
	newData: AvailableDates.Update,
): Promise<AvailableDates.AvailableDate> => {
	const { id, ...body } = newData;
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const destroy = async (id: string): Promise<AvailableDates.AvailableDate> => {
	const { data } = await api.delete(`${DOMAIN}/${id}`);
	return data;
};

const AvailableDateService = {
	get,
	create,
	patch,
	destroy,
};

export { AvailableDateService };
